import pxToRem from '../theme/pxToRem';
import { alpha } from '@mui/material/styles';
import palette from '../theme/palette';
import breakpoints from '../theme/breakpoints';
import { buttonClasses } from '@mui/material';
import colors from '../theme/colors';
import { BUTTON_BORDER_RADIUS } from '../theme/constants';

const styleOverrides = {
  root: {
    borderRadius: BUTTON_BORDER_RADIUS,
    [`@media only screen and (min-width: ${breakpoints.md}px)`]: {
      whiteSpace: 'nowrap',
    },
  },
  outlined: {
    borderWidth: '2px',
    padding: '7px 30px',
    [`&.${buttonClasses.disabled}`]: {
      color: palette.text.disabled,
      borderColor: palette.text.disabled,
    },
    '&:hover': {
      borderWidth: '2px',
    },
  },
  text: {
    padding: '8px 30px',
    [`&.${buttonClasses.disabled}`]: {
      color: palette.text.disabled,
      backgroundColor: colors.transparentGray[100],
    },
  },
  opaque: {
    [`&.${buttonClasses.disabled}`]: {
      color: palette.text.disabled,
    },
  },
  contained: {
    padding: '8px 30px',
    [`&.${buttonClasses.disabled}`]: {
      color: palette.common.white,
      backgroundColor: palette.text.disabled,
    },
  },
  textPrimary: {
    backgroundColor: alpha(colors.brandPrimary[150], 0.4),
    '&:hover': {
      backgroundColor: alpha(colors.brandPrimary[150], 0.46 + palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
  textSecondary: {
    backgroundColor: alpha(palette.secondary.main, 0.06),
    '&:hover': {
      backgroundColor: alpha(palette.secondary.main, 0.06 + palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
  outlinedSizeSmall: {
    fontSize: pxToRem(12),
    padding: '4.5px 20px',
  },
  textSizeSmall: {
    fontSize: pxToRem(12),
    padding: '5.5px 20px',
  },
  containedSizeSmall: {
    fontSize: pxToRem(12),
    padding: '5.5px 20px',
  },
  outlinedSizeLarge: {
    fontSize: pxToRem(18),
    padding: '7.5px 32px',
  },
  textSizeLarge: {
    fontSize: pxToRem(18),
    padding: '8.5px 32px',
  },
  containedSizeLarge: {
    fontSize: pxToRem(18),
    padding: '8.5px 32px',
  },
};

export default styleOverrides;
